var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fn org item pp-header__title sold-out"},[_vm._v("SOLD OUT")])
}
var staticRenderFns = []

export { render, staticRenderFns }